export const EMPLOYEE_TABLE_PAGE_SIZE = 30;

export enum UserPref {
  IsSidebarExpanded = 'isSidebarExpanded',
}
